import styles from './title.module.css';

export default function Title({ text }: { text: string }) {
	return (
		<div className={styles.title}>
			<h1 className={styles.text}>{text}</h1>
		</div>
	);
}
